import { render } from "./CertificateActions.vue?vue&type=template&id=4d044745&scoped=true"
import script from "./CertificateActions.vue?vue&type=script&lang=js"
export * from "./CertificateActions.vue?vue&type=script&lang=js"

import "./CertificateActions.vue?vue&type=style&index=0&id=4d044745&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d044745"]])

export default __exports__